import { LayoutModule } from 'src/app/layout/layout.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DashboardIndexComponent } from './dashboard-index/dashboard-index.component';
import { WidgetComponent } from './widget/widget.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DesignerComponent } from './designer/designer.component';
import { NgZorroModule } from 'src/app/ng-zorro.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ParamsBaseComponent } from './dashboard-params/params-base/params-base.component';
import { ParamSelectComponent } from './dashboard-params/param-select/param-select.component';
import { DashboardContainerComponent } from './dashboard-container/dashboard-container.component';
import { ShoppingCartService } from '../shoppingCart/shoppingCart.service';
import { CartProductsWidgetComponent } from './widget/cart-products-widget/cart-products-widget.component';
import { ParamDateComponent } from './dashboard-params/param-date/param-date.component';

@NgModule({
  declarations: [
    DashboardIndexComponent,
    WidgetComponent,
    DesignerComponent,
    ParamsBaseComponent,
    ParamSelectComponent,
    DashboardContainerComponent,
    CartProductsWidgetComponent,
    ParamDateComponent,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    NgxChartsModule,
    DragDropModule,
    FormsModule,
    LayoutModule,
  ],
  exports: [DashboardIndexComponent, WidgetComponent],
  providers: [ShoppingCartService],
})
export class DashboardModule {}
